import React from "react";
import Button from "../../../pageComponents/Settings/Free/Button";
import Grid from "@material-ui/core/Grid";
import WoodenInput from "../../../pageComponents/Settings/Free/WoodenInput";
import axios from "axios";
import {freeGiftRedeem} from "../../../../Utility/Url";
import PicoLoader from "../../Common/PicoLoader";
import Exit from "../../../../assets/images/exit.png";

class PrizeCode extends React.Component {
    constructor() {
        super();
        this.inputRef = React.createRef()
        this.state={
            picoSmallLoader:false
        }
    }
    handleInput=(data)=>{
    }
    handleClick=async ()=>{
        this.setState({
            picoSmallLoader:true
        })
        const code=this.inputRef.current.state.input
        if (code===undefined){
            const obj=
                {
                    dialog:{
                        id: 0,
                        icon:Exit,
                        title: "خطا",
                        message: "لطفا کد جایزه را وارد کنید",
                        ok: null,
                        cancel: {
                            text: "بستن",
                            action: "#cancel"
                        },
                        style: {
                            type: "danger",
                            borderColor: "#7b241c",
                            background: "#c0392b",
                            contentColor: "#d98880",
                            contentTextColor: "#ffffff"
                        }
                    }
                }
            this.props.callBack(obj)
            this.setState({
                picoSmallLoader:false
            })
        }else {
            await axios.post(freeGiftRedeem,{
                code:code
            })
                .then(res => {
                    this.setState({
                        picoSmallLoader:false
                    })
                    const {data}=res
                    this.props.callBack(data)
                }).catch(error=>{
                        console.log(error.toString())
                    }
                )
        }

    }
    render() {
        const {icon,text,buttonText,buttonTextColor,buttonColor,firstLayerColor,secondLayerColor,thirdLayerColor}=this.props.data
        const button={
            text:buttonText,
            backgroundColor:buttonColor,
            bottomFontSize:'15px',
            buttonTextColor:buttonTextColor
        }
        const woodenInput={
            backgroundColor:'lightblue',
            layerRadius:'15px',
            inputTextSize:'30px',
            inputMaxLength:'7',
        }
        const{picoSmallLoader}=this.state
        return(
            <Grid justify={'center'} className='item-holder' sm={12} xs={12} item container style={{backgroundColor:firstLayerColor}}>
                <Grid alignItems={"center"} justify={"center"} sm={12} xs={12} item container className='item-holder-first-layer' style={{backgroundColor:secondLayerColor}}>
                    <Grid sm={12} xs={12} justify={"center"} alignItems={"center"} item container className='item-holder-first-layer-second-layer' style={{backgroundColor:thirdLayerColor}}>
                        <Grid  container alignItems={"center"} sm={12} xs={12} item>
                            <Grid sm={11} xs={11} justify={"flex-end"} container alignItems={"center"} item >
                              <p>
                                  {text}
                              </p>
                            </Grid>
                            <Grid container sm={11} xs={11} alignItems={"center"} justify={"space-around"} item style={{width:'100%'}}>

                                <Grid sm={3} xs={3} item container justify={"center"} alignItems={"center"}>
                                    {
                                        !picoSmallLoader&&
                                        <Grid sm={12} style={{position:'relative',height:'60px'}} xs={12} alignItems={"center"} onClick={() => { this.handleClick() }} className='clickable' justify={"center"} container>
                                            <Button data={button}/>
                                        </Grid>
                                    }
                                    {
                                        picoSmallLoader &&
                                        <Grid sm={5} xs={5} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                              style={{position:'relative',height:'50px'}}
                                        >
                                            <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                                <PicoLoader/>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid sm={7} xs={7} item >
                                    <WoodenInput input={this.handleClick}  ref={this.inputRef} data={woodenInput}/>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default PrizeCode